import casesMobWebp1 from '../../images/cases/mobile/cases1.webp';
import casesMobWebp2x1 from '../../images/cases/mobile/cases1@2x.webp';
import casesMobJpeg1 from '../../images/cases/mobile/cases1.jpg';
import casesMobJpeg2x1 from '../../images/cases/mobile/cases1@2x.jpg';
import casesMobWebp2 from '../../images/cases/mobile/cases2.webp';
import casesMobWebp2x2 from '../../images/cases/mobile/cases2@2x.webp';
import casesMobJpeg2 from '../../images/cases/mobile/cases2.jpg';
import casesMobJpeg2x2 from '../../images/cases/mobile/cases2@2x.jpg';
import casesMobWebp3 from '../../images/cases/mobile/cases3.webp';
import casesMobWebp2x3 from '../../images/cases/mobile/cases3@2x.webp';
import casesMobJpeg3 from '../../images/cases/mobile/cases3.jpg';
import casesMobJpeg2x3 from '../../images/cases/mobile/cases3@2x.jpg';
import casesMobWebp4 from '../../images/cases/mobile/cases4.webp';
import casesMobWebp2x4 from '../../images/cases/mobile/cases4@2x.webp';
import casesMobJpeg4 from '../../images/cases/mobile/cases4.jpg';
import casesMobJpeg2x4 from '../../images/cases/mobile/cases4@2x.jpg';
import casesMobWebp5 from '../../images/cases/mobile/cases5.webp';
import casesMobWebp2x5 from '../../images/cases/mobile/cases5@2x.webp';
import casesMobJpeg5 from '../../images/cases/mobile/cases5.jpg';
import casesMobJpeg2x5 from '../../images/cases/mobile/cases5@2x.jpg';
import casesMobWebp6 from '../../images/cases/mobile/cases6.webp';
import casesMobWebp2x6 from '../../images/cases/mobile/cases6@2x.webp';
import casesMobJpeg6 from '../../images/cases/mobile/cases6.jpg';
import casesMobJpeg2x6 from '../../images/cases/mobile/cases6@2x.jpg';

import casesTabWebp1 from '../../images/cases/tablet/cases1.webp';
import casesTabWebp2x1 from '../../images/cases/tablet/cases1@2x.webp';
import casesTabJpeg1 from '../../images/cases/tablet/cases1.jpg';
import casesTabJpeg2x1 from '../../images/cases/tablet/cases1@2x.jpg';
import casesTabWebp2 from '../../images/cases/tablet/cases2.webp';
import casesTabWebp2x2 from '../../images/cases/tablet/cases2@2x.webp';
import casesTabJpeg2 from '../../images/cases/tablet/cases2.jpg';
import casesTabJpeg2x2 from '../../images/cases/tablet/cases2@2x.jpg';
import casesTabWebp3 from '../../images/cases/tablet/cases3.webp';
import casesTabWebp2x3 from '../../images/cases/tablet/cases3@2x.webp';
import casesTabJpeg3 from '../../images/cases/tablet/cases3.jpg';
import casesTabJpeg2x3 from '../../images/cases/tablet/cases3@2x.jpg';
import casesTabWebp4 from '../../images/cases/tablet/cases4.webp';
import casesTabWebp2x4 from '../../images/cases/tablet/cases4@2x.webp';
import casesTabJpeg4 from '../../images/cases/tablet/cases4.jpg';
import casesTabJpeg2x4 from '../../images/cases/tablet/cases4@2x.jpg';
import casesTabWebp5 from '../../images/cases/tablet/cases5.webp';
import casesTabWebp2x5 from '../../images/cases/tablet/cases5@2x.webp';
import casesTabJpeg5 from '../../images/cases/tablet/cases5.jpg';
import casesTabJpeg2x5 from '../../images/cases/tablet/cases5@2x.jpg';
import casesTabWebp6 from '../../images/cases/tablet/cases6.webp';
import casesTabWebp2x6 from '../../images/cases/tablet/cases6@2x.webp';
import casesTabJpeg6 from '../../images/cases/tablet/cases6.jpg';
import casesTabJpeg2x6 from '../../images/cases/tablet/cases6@2x.jpg';

import casesDeskWebp1 from '../../images/cases/desktop/cases1.webp';
import casesDeskWebp2x1 from '../../images/cases/desktop/cases1@2x.webp';
import casesDeskJpeg1 from '../../images/cases/desktop/cases1.jpg';
import casesDeskJpeg2x1 from '../../images/cases/desktop/cases1@2x.jpg';
import casesDeskWebp2 from '../../images/cases/desktop/cases2.webp';
import casesDeskWebp2x2 from '../../images/cases/desktop/cases2@2x.webp';
import casesDeskJpeg2 from '../../images/cases/desktop/cases2.jpg';
import casesDeskJpeg2x2 from '../../images/cases/desktop/cases2@2x.jpg';
import casesDeskWebp3 from '../../images/cases/desktop/cases3.webp';
import casesDeskWebp2x3 from '../../images/cases/desktop/cases3@2x.webp';
import casesDeskJpeg3 from '../../images/cases/desktop/cases3.jpg';
import casesDeskJpeg2x3 from '../../images/cases/desktop/cases3@2x.jpg';
import casesDeskWebp4 from '../../images/cases/desktop/cases4.webp';
import casesDeskWebp2x4 from '../../images/cases/desktop/cases4@2x.webp';
import casesDeskJpeg4 from '../../images/cases/desktop/cases4.jpg';
import casesDeskJpeg2x4 from '../../images/cases/desktop/cases4@2x.jpg';
import casesDeskWebp5 from '../../images/cases/desktop/cases5.webp';
import casesDeskWebp2x5 from '../../images/cases/desktop/cases5@2x.webp';
import casesDeskJpeg5 from '../../images/cases/desktop/cases5.jpg';
import casesDeskJpeg2x5 from '../../images/cases/desktop/cases5@2x.jpg';
import casesDeskWebp6 from '../../images/cases/desktop/cases6.webp';
import casesDeskWebp2x6 from '../../images/cases/desktop/cases6@2x.webp';
import casesDeskJpeg6 from '../../images/cases/desktop/cases6.jpg';
import casesDeskJpeg2x6 from '../../images/cases/desktop/cases6@2x.jpg';

const pictures = [
  {
    mobWebp: casesMobWebp1,
    mobWebp2x: casesMobWebp2x1,
    mobJpeg: casesMobJpeg1,
    mobJpeg2x: casesMobJpeg2x1,
    tabWebp: casesTabWebp1,
    tabWebp2x: casesTabWebp2x1,
    tabJpeg: casesTabJpeg1,
    tabJpeg2x: casesTabJpeg2x1,
    deskWebp: casesDeskWebp1,
    deskWebp2x: casesDeskWebp2x1,
    deskJpeg: casesDeskJpeg1,
    deskJpeg2x: casesDeskJpeg2x1,
  },
  {
    mobWebp: casesMobWebp2,
    mobWebp2x: casesMobWebp2x2,
    mobJpeg: casesMobJpeg2,
    mobJpeg2x: casesMobJpeg2x2,
    tabWebp: casesTabWebp2,
    tabWebp2x: casesTabWebp2x2,
    tabJpeg: casesTabJpeg2,
    tabJpeg2x: casesTabJpeg2x2,
    deskWebp: casesDeskWebp2,
    deskWebp2x: casesDeskWebp2x2,
    deskJpeg: casesDeskJpeg2,
    deskJpeg2x: casesDeskJpeg2x2,
  },
  {
    mobWebp: casesMobWebp3,
    mobWebp2x: casesMobWebp2x3,
    mobJpeg: casesMobJpeg3,
    mobJpeg2x: casesMobJpeg2x3,
    tabWebp: casesTabWebp3,
    tabWebp2x: casesTabWebp2x3,
    tabJpeg: casesTabJpeg3,
    tabJpeg2x: casesTabJpeg2x3,
    deskWebp: casesDeskWebp3,
    deskWebp2x: casesDeskWebp2x3,
    deskJpeg: casesDeskJpeg3,
    deskJpeg2x: casesDeskJpeg2x3,
  },
  {
    mobWebp: casesMobWebp4,
    mobWebp2x: casesMobWebp2x4,
    mobJpeg: casesMobJpeg4,
    mobJpeg2x: casesMobJpeg2x4,
    tabWebp: casesTabWebp4,
    tabWebp2x: casesTabWebp2x4,
    tabJpeg: casesTabJpeg4,
    tabJpeg2x: casesTabJpeg2x4,
    deskWebp: casesDeskWebp4,
    deskWebp2x: casesDeskWebp2x4,
    deskJpeg: casesDeskJpeg4,
    deskJpeg2x: casesDeskJpeg2x4,
  },
  {
    mobWebp: casesMobWebp5,
    mobWebp2x: casesMobWebp2x5,
    mobJpeg: casesMobJpeg5,
    mobJpeg2x: casesMobJpeg2x5,
    tabWebp: casesTabWebp5,
    tabWebp2x: casesTabWebp2x5,
    tabJpeg: casesTabJpeg5,
    tabJpeg2x: casesTabJpeg2x5,
    deskWebp: casesDeskWebp5,
    deskWebp2x: casesDeskWebp2x5,
    deskJpeg: casesDeskJpeg5,
    deskJpeg2x: casesDeskJpeg2x5,
  },
  {
    mobWebp: casesMobWebp6,
    mobWebp2x: casesMobWebp2x6,
    mobJpeg: casesMobJpeg6,
    mobJpeg2x: casesMobJpeg2x6,
    tabWebp: casesTabWebp6,
    tabWebp2x: casesTabWebp2x6,
    tabJpeg: casesTabJpeg6,
    tabJpeg2x: casesTabJpeg2x6,
    deskWebp: casesDeskWebp6,
    deskWebp2x: casesDeskWebp2x6,
    deskJpeg: casesDeskJpeg6,
    deskJpeg2x: casesDeskJpeg2x6,
  },
];

export const images = {
  pictures,
};
